import selectors from "./selectors";

/**
 * This module deals with data embedded into the CRMTask type.
 */

export default {
  selectors,
};
